/**
 * CSV export of a students table: the columns the teacher sees, in the
 * order they sorted them. Each column says what it writes (its `csv`
 * cells, lib/studentTable.js), so the Students tab and every drill-down
 * export through this one function; the default is the Students tab's.
 *
 * Cells a spreadsheet would read as a formula (a name starting with "=",
 * "+", "-" or "@") are prefixed with an apostrophe, so a student cannot
 * put a formula into a teacher's spreadsheet through their display name.
 */
import { STUDENT_COLUMNS } from './studentTable';

const FORMULA_START = /^[=+\-@\t\r]/;

const cell = (value) => {
  if (value == null) return '';
  let text = String(value);
  if (typeof value === 'string' && FORMULA_START.test(text)) text = `'${text}`;
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export function studentsCsv(students, columns = STUDENT_COLUMNS) {
  const cells = columns.flatMap((c) => c.csv);
  const header = cells.map((c) => c.label);
  const rows = students.map((s) => cells.map((c) => c.value(s)));
  return [header, ...rows].map((row) => row.map(cell).join(',')).join('\n');
}

/** "whole_school_students.csv" from a scope label. */
export function csvFilename(label) {
  const safe = String(label || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  return `${safe || 'students'}_students.csv`;
}
